import { useState, createContext, useContext } from "react";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { DashboardSidebar } from "@/components/DashboardSidebar";
import { NewAnalysisDialog } from "@/components/NewAnalysisDialog";

interface DashboardContextType {
  openNewAnalysis: () => void;
}

const DashboardContext = createContext<DashboardContextType>({ openNewAnalysis: () => {} });

export function useDashboardContext() {
  return useContext(DashboardContext);
}

export default function DashboardLayout({ children }: { children: React.ReactNode }) {
  const [newAnalysisOpen, setNewAnalysisOpen] = useState(false);

  const openNewAnalysis = () => setNewAnalysisOpen(true);

  return (
    <DashboardContext.Provider value={{ openNewAnalysis }}>
      <SidebarProvider>
        <div className="min-h-screen flex w-full">
          <DashboardSidebar onNewAnalysis={openNewAnalysis} />
          <div className="flex-1 flex flex-col">
            <header className="h-14 flex items-center border-b border-border px-4">
              <SidebarTrigger className="text-muted-foreground" />
            </header>
            <main className="flex-1 p-4 sm:p-6">{children}</main>
          </div>
        </div>
        <NewAnalysisDialog open={newAnalysisOpen} onOpenChange={setNewAnalysisOpen} />
      </SidebarProvider>
    </DashboardContext.Provider>
  );
}
